import { GlobalService } from 'src/app/services/global.service';
import { FirebaseService } from 'src/app/services/firebase.service';
import { Component, Input, OnInit, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { LoggedUpdate } from 'sharedTypes/client';

@Component({
    selector: 'app-protokoll',
    templateUrl: './protokoll.component.html',
    styleUrls: ['./protokoll.component.scss'],
    standalone: false,
})
export class ProtokollComponent implements OnInit, OnDestroy {
    @Input() clientId: string = '';
    @Input() leadId: string = '';
    logins: Array<{ account: string; admin: string; date: number; dateIso: string }> = [];
    updates: Array<LoggedUpdate> = [];
    loginSub: Subscription = new Subscription();
    updatesSub: Subscription = new Subscription();

    constructor(private firebaseService: FirebaseService, public glo: GlobalService) {}

    ngOnInit(): void {
        if (this.clientId) {
            this.loginSub = this.firebaseService.getClientLogins(this.clientId).subscribe((logins) => {
                this.logins = logins;
            });
        }

        this.updatesSub = this.firebaseService.getClientUpdates(this.clientId || this.leadId).subscribe((updates) => {
            this.updates = updates;
        });
    }

    ngOnDestroy(): void {
        this.loginSub.unsubscribe();
        this.updatesSub.unsubscribe();
    }
}
